import React, { FC, useState } from 'react';

import { AutoPayIcon } from '../../AutoPayIcon';
import { AutoPaySecondAttemptContent } from '../../AutoPaySecondAttemptContent';
import { AutoPayFeatureList } from '../components/AutoPayFeatureList/AutoPayFeatureList';
import { AutoPayHeader } from '../components/AutoPayHeader/AutoPayHeader';
import Card, { LoadingCard, ErrorCard } from 'src/commons/components/Card';

import {
  AutoPayActionsContainer,
  AutoPayAcceptButton,
  DeclineButton,
} from './styles';

interface AutoPaySetupConditionalProps {
  fetchingApplication: boolean;
  showApplicationFetchError: boolean;
  maskedAccountNumber: string;
  bankName: string;
  onSetupClick: Function;
  saveAutoPayPreferencesDeclined: Function;
  submitting: boolean;
}

// AutoPay Setup for applications that DO require a bank account
export const AutoPaySetupConditional: FC<AutoPaySetupConditionalProps> = ({
  fetchingApplication,
  showApplicationFetchError,
  maskedAccountNumber,
  bankName,
  onSetupClick,
  saveAutoPayPreferencesDeclined,
  submitting,
}) => {
  const [showSecondAttemptCard, setShowSecondAttemptCard] = useState(false);

  const handleSkipClick = () => {
    if (showSecondAttemptCard) {
      saveAutoPayPreferencesDeclined();
    } else {
      setShowSecondAttemptCard(true);
    }
  };

  if (fetchingApplication) {
    return <LoadingCard />;
  }

  if (showApplicationFetchError) {
    return <ErrorCard />;
  }

  return (
    <Card id="autopay-setup-card">
      {showSecondAttemptCard ? (
        <AutoPaySecondAttemptContent />
      ) : (
        <>
          <AutoPayIcon />
          <AutoPayHeader
            isConditional
            bankName={bankName}
            maskedAccountNumber={maskedAccountNumber}
          />

          <AutoPayFeatureList isConditional />
        </>
      )}
      <AutoPayActionsContainer>
        <AutoPayAcceptButton id="autopay-accept-button" onClick={onSetupClick}>
          {showSecondAttemptCard ? 'Set up AutoPay' : 'Yes, set up AutoPay'}
        </AutoPayAcceptButton>
        <DeclineButton
          id="autopay-decline-button"
          onClick={handleSkipClick}
          disabled={submitting}
        >
          {showSecondAttemptCard ? 'Skip AutoPay for now' : 'No thanks'}
        </DeclineButton>
      </AutoPayActionsContainer>
    </Card>
  );
};
